const trendingReducer = (state = [], {type, restaurants}) => {
    switch(type) {
        case 'SET_TRENDING':
            return restaurants;
        default: 
            return state;
    }
}

export default trendingReducer;